import 'normalize.css';
import 'font-awesome/css/font-awesome.css';

import template from './app.html';
import './app.scss';

import '../../../common/assets/scss/common.scss';
import '../../../common/assets/scss/ods.scss';

export default {
  template,
  transclude: true,
};
